import type { ReactNode } from 'react';

export const symbol_cloud_circle: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M337-333h302q47 0 81-29.5t34-74.5q0-45-34-74t-81-29q-5-62-47-106.5T488-691q-52 0-94.5 28.5T337-584q-54 0-92 36.5T207-458q0 53 38 89t92 36Zm0-60q-29 0-49.5-18.5T267-458q0-28 20.5-47t49.5-19h52v-16q0-39 29.5-65t69.5-26q38 0 64.5 26.5T579-540v60h60q21 0 38 11.5t17 31.5q0 20-16.5 32T639-393H337ZM480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-156t86-127Q252-817 325-848.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 82-31.5 155T763-197.5q-54 54.5-127 86T480-80Zm0-60q142 0 241-99.5T820-480q0-142-99-241t-241-99q-141 0-240.5 99T140-480q0 141 99.5 240.5T480-140Zm0-340Z"
		/>
	</svg>
);
